import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot,Resolve,RouterStateSnapshot,Routes} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {UserRouteAccessService} from 'src/app/core';
import {DataManagementGuardService} from 'src/app/core/auth/data-management-guard.service';
import {Delegation,IDelegation} from 'src/app/shared/model/delegation.model';
import {IUnderwriterMySuffix,UnderwriterMySuffix} from 'src/app/shared/model/underwriter-my-suffix.model';
import {UnderwriterMySuffixAccessPopupComponent} from '.';
import {DelegationMySuffixService} from './../underwriter-insurer-my-suffix/delegation-my-suffix.service';
import {DelegationMySuffixDetailComponent} from './delegations/delegation-my-suffix-detail/delegation-my-suffix-detail.component';
import {DelegationMySuffixUpdateComponent} from './delegations/delegation-my-suffix-update/delegation-my-suffix-update.component';
import {UnderwriterMySuffixDeletePopupComponent} from './underwriter-my-suffix-delete-dialog.component';
import {UnderwriterMySuffixDetailComponent} from './underwriter-my-suffix-detail.component';
import {UnderwriterMySuffixUpdateComponent} from './underwriter-my-suffix-update.component';
import {UnderwriterMySuffixComponent} from './underwriter-my-suffix.component';
import {UnderwriterMySuffixService} from './underwriter-my-suffix.service';

@Injectable({ providedIn: 'root' })
export class UnderwriterMySuffixResolve implements Resolve<IUnderwriterMySuffix> {
    constructor(private service: UnderwriterMySuffixService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {

            if (state.url.includes('view')) {
                return this.service.view(id).map((underwriter: HttpResponse<UnderwriterMySuffix>) => underwriter.body);
            } else {
                return this.service.find(id).map((underwriter: HttpResponse<UnderwriterMySuffix>) => underwriter.body);
            }

        }
        return Observable.of(new UnderwriterMySuffix());
    }
}
@Injectable({ providedIn: 'root' })
export class DelegationMySuffixResolve implements Resolve<IDelegation> {
    constructor(private service: DelegationMySuffixService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['dId'] ? route.params['dId'] : null;
        if (id) {
            return this.service.find(id).map((delegation: HttpResponse<IDelegation>) => delegation.body);

            // if (state.url.includes('view')) {
            // } else {
            //     return this.service.find(id).map((underwriter: HttpResponse<IDelegation>) => underwriter.body);
            // }

        }
        return Observable.of(new Delegation());
    }
}

export const underwriterRoute: Routes = [
    {
        path: 'underwriter',
        component: UnderwriterMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                // 'ROLE_USER',
                // 'ROLE_ADMIN',
                // 'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService]
    },
    {
        path: 'underwriter/:id/view',
        component: UnderwriterMySuffixDetailComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve,
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                // 'ROLE_USER',
                // 'ROLE_ADMIN',
                // 'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
        runGuardsAndResolvers:'always'
    },
    {
        path: 'underwriter/new',
        component: UnderwriterMySuffixUpdateComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                // 'ROLE_USER',
                // 'ROLE_ADMIN',
                // 'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService]
    },
    {
        path: 'underwriter/:id/edit',
        component: UnderwriterMySuffixUpdateComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                // 'ROLE_USER',
                // 'ROLE_ADMIN',
                // 'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService]
    },
    {
        path: 'underwriter/delegation/:id/new',
        component: DelegationMySuffixUpdateComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Delegations'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
    },
    {
        path: 'underwriter/delegation/:id/:dId/edit',
        component: DelegationMySuffixUpdateComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Delegations'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
    },
    {
        path: 'underwriter/delegation/:uId/:dId/view',
        component: DelegationMySuffixDetailComponent,
        resolve: {
            delegation: DelegationMySuffixResolve
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
    },
    {
        path: 'underwriter/delegation/renew/:id/:dId/edit',
        component: DelegationMySuffixUpdateComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Delegations'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
    }

];

export const underwriterPopupRoute: Routes = [
    {
        path: 'underwriter/:id/delete',
        component: UnderwriterMySuffixDeletePopupComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                // 'ROLE_USER',
                // 'ROLE_ADMIN',
                // 'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
        outlet: 'popup'
    },
    {
        path: 'underwriter/:id/access',
        component: UnderwriterMySuffixAccessPopupComponent,
        resolve: {
            underwriter: UnderwriterMySuffixResolve
        },
        data: {
            authorities: [
                // 'ROLE_USER',
                // 'ROLE_ADMIN',
                // 'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Underwriters'
        },
        canActivate: [UserRouteAccessService,DataManagementGuardService],
        outlet: 'popup'
    }];
